import { DateMarker } from '@fullcalendar/core/internal';
import { number } from 'yup';

// Reuse these on the frontend
export type ISODate = string; // "2025-09-10T10:54:57.999Z"
export enum LeadsCancelReasons {
  NO_ANSWER = 'no_answer',
  REFUSED_FOREVER = 'refused_forever',
  REFUSED_TEMPORARILY = 'refused_temporarily',
  OTHER = 'other',
}

export enum LeadStage {
  CONTACTING = 'contacting',
  WEBINAR = 'webinar',
  ACTIVITY = 'activity',
}

export type SourceMeta = Record<string, unknown>;
export enum LeadStatus {
  NEW = 'new',
  DECLINED = 'declined',
  CONVERTED = 'converted',
}

export type LeadTab = {
  id: number;
  label: string;
  value: LeadStatus;
};
export type LeadsNewTabFiltersType = {
  id: number;
  value: LeadStage | 'all';
  defaultChecked: boolean;
};
/** 1:1 row with milestone flags/timestamps for a lead */
// export interface LeadEvent {
//   id: number;
//   leadId: number;

//   // Initial call
//   initCall: boolean;
//   initCallDeadline: ISODate | null; // nullable on API if not set yet
//   initCallDate: ISODate | null;
//   initCallComment: string | null;
//   initCallScreen: string | null;
//   initCallResult: CallOutcome | null;

//   inviteCommentDate: ISODate | null;
//   inviteSendDeadline: ISODate | null;
//   inviteSentComment: string | null;
//   inviteSentScreen: string | null;
//   isInviteSent: boolean | null;
//   // Meet scheduling
//   meetCallDate: ISODate | null;
//   googleMeetLink: string | null;
//   meetEntityId: number | null;
//   meetApproveComment: string | null;
//   meetApproveScreen: string | null;
//   meetApproveDate: ISODate | null;
//   meetApproveDeadline: ISODate | null;

//   leadJoinMeetCheckDeadline: ISODate | null;
//   leadJoinMeetCheckComment: string | null;
//   leadJoinMeetCheckScreen: string | null;
//   leadJoinMeetCheckDate: ISODate | null;
//   // Second call
//   secondCall: boolean;
//   secondCallDate: ISODate | null;
//   secondCallComment: string | null;
//   secondCallScreen: string | null;
//   secondCallResult: CallOutcome | null;
//   secondCallDeadline: ISODate | null;

//   checkUserActiveDeadline: boolean | null;
//   createAccountDeadline: ISODate | null;
//   createAccountComment: string | null;
//   createAccountScreen: string | null;
//   createAccountDate: ISODate | null;

//   // Funnel flags / account
//   formFilled: boolean | null;
//   accountCreated: boolean | null; // ← boolean, not Date
//   createdAccountId: number | null;
//   isActiveUser: boolean | null;
//   isActiveUserComment: string | null;
//   sendCredsComment: string | null;
//   sendCredsDate: ISODate | null;
//   sendCredsDeadline: ISODate | null;
//   sendCredsScreen: string | null;

//   sendNotificationDate: ISODate | null;
//   sendNotificationComment: string | null;
//   sendNotificationScreen: string | null;
//   sendNotificationDeadline: ISODate | null;

//   checkStartStudyDeadline: ISODate | null;
//   checkStartStudyComment: string | null;
//   checkStartStudyScreen: string | null;
//   checkStartStudyDate: ISODate | null;
//   // Audit
//   createdById: number | null;
//   createdAt: ISODate;
//   updatedAt: ISODate;
// }
export enum LeadStageStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
}

export interface Flow {
  createdAt: ISODate;
  id: number;
  leadId: number;
  stage: LeadStage;
  stageStatus: LeadStageStatus;
  dataRows: FlowData[];
  updatedAt: ISODate;
  position: number;
}
export interface FlowData {
  id: number;
  task: string;
  taskType: TaskType;
  leadFlowId: number;
  createdAt: ISODate;
  updatedAt: ISODate;
  comment: string;
  deadline: ISODate;
  files:
    | {
        name: string;
        url: string;
        size?: number;
        type?: string;
      }[]
    | null;
}
/** Lead with embedded 1:1 event row */
export interface SingleLeadData {
  id: number;
  fullName: string;
  email: string | null; // nullable in DB
  phone: string | null; // nullable in DB
  source: string | null;
  stage: LeadStage;
  userId: number | null;
  createdAt: ISODate;
  updatedAt: ISODate;
  leadCreatedDate: ISODate | null; // nullable column
  sourceMeta: SourceMeta;
  status: LeadStatus;
  // In code we "ensure" it exists, but make it tolerant in types:
  flows: Flow[];
  cancel_reason?: LeadsCancelReasons | null;
  cancel_comment?: string | null;
  closed_at?: ISODate | null;
}
export type LeadUpdateArgs = { dataFlowId: number; formData: FormData };

export interface LeadInput {
  id: number;
  data: FlowData[] | [];
  showFullImageHandler: (url: string) => void;
  handleOpenCreateActionModal: (id: number) => void;
  setNewAction: (id: number) => void;
  position: number;
  updated: ISODate;
  stage: string;
  stageStatus: LeadStageStatus;
}

export interface LeadsControlsInput {
  id: number;
  position: number;
  // type: 'init' | 'second' | 'unset';
  data: FlowData[] | [];
  showFullImageHandler: (url: string) => void;
  handleOpenCreateActionModal: (id: number) => void;
  setNewAction: (id: number) => void;
  deadline?: string | null | undefined;
  updated?: string | null | undefined;
  stage: string;
}

export type LeadsTaskTableColumns = {
  task: string;
  deadline: Date;
  updatedAt: Date;
  comment: string;
};
export enum TaskType {
  CALL = 'call',
  EMAIL = 'email',
  OTHER = 'other',
}
